import { render } from "./Icon.vue?vue&type=template&id=4fc1541c&scoped=true"
import script from "./Icon.vue?vue&type=script&lang=js"
export * from "./Icon.vue?vue&type=script&lang=js"

import "./Icon.vue?vue&type=style&index=0&id=4fc1541c&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fc1541c"]])

export default __exports__